function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import BaseModule from './BaseModule'; // import IconAlignLeft from '../assets/pencil.svg'
// import IconAlignCenter from '../assets/pencil.svg'
// import IconAlignRight from '../assets/pencil.svg'
// import IconFloatFull from '../assets/pencil.svg'
// import IconPencil from '../assets/pencil.svg'

import _Quill from 'quill';
var Quill = window.Quill || _Quill;
var Parchment = Quill.import('parchment'); // Quill.js 2.x support

var ClassAttributor = Parchment.ClassAttributor ? Parchment.ClassAttributor : Parchment.Attributor.Class;
var ImageFormatClass = new ClassAttributor('imagestyle', 'ql-resize-style');

var Toolbar = /*#__PURE__*/function (_BaseModule) {
  _inherits(Toolbar, _BaseModule);

  var _super = _createSuper(Toolbar);

  function Toolbar() {
    _classCallCheck(this, Toolbar);

    return _super.apply(this, arguments);
  }

  _createClass(Toolbar, [{
    key: "onCreate",
    value: function onCreate() {
      // Setup Toolbar
      this.toolbar = document.createElement('div');
      Object.assign(this.toolbar.style, this.options.styles.toolbar);
      this.overlay.appendChild(this.toolbar); // Setup Buttons

      this._defineAlignments();

      this._addToolbarButtons();
    }
  }, {
    key: "_defineAlignments",
    value: function _defineAlignments() {
      var _this = this;

      this.alignments = [{
        icon: "<svg viewbox=\"0 0 18 18\">\n        <path class=\"ql-fill\" d=\"M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z\"/>\n        <path class=\"ql-fill\" d=\"M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z\"/>\n        <path class=\"ql-fill\" d=\"M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z\"/>\n        <path class=\"ql-fill\" d=\"M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z\"/>\n        <rect class=\"ql-fill\" x=\"2\" y=\"6\" width=\"8\" height=\"6\" rx=\"1\" ry=\"1\"/>\n      </svg>",
        apply: function apply() {
          ImageFormatClass.add(_this.activeEle, 'left');
        },
        isApplied: function isApplied() {
          return ImageFormatClass.value(_this.activeEle) === 'left';
        }
      }, {
        icon: "<svg viewbox=\"0 0 18 18\">\n        <path class=\"ql-fill\" d=\"M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z\"/>\n        <path class=\"ql-fill\" d=\"M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z\"/>\n        <rect class=\"ql-fill\" x=\"3\" y=\"6\" width=\"12\" height=\"6\" rx=\"1\" ry=\"1\"/>\n      </svg>",
        apply: function apply() {
          ImageFormatClass.add(_this.activeEle, 'center');
        },
        isApplied: function isApplied() {
          return ImageFormatClass.value(_this.activeEle) === 'center';
        }
      }, {
        icon: "<svg viewbox=\"0 0 18 18\">\n        <path class=\"ql-fill\" d=\"M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z\"/>\n        <path class=\"ql-fill\" d=\"M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z\"/>\n        <path class=\"ql-fill\" d=\"M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z\"/>\n        <path class=\"ql-fill\" d=\"M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z\"/>\n        <rect class=\"ql-fill\" x=\"8\" y=\"6\" width=\"8\" height=\"6\" rx=\"1\" ry=\"1\" transform=\"translate(24 18) rotate(-180)\"/>\n      </svg>",
        apply: function apply() {
          ImageFormatClass.add(_this.activeEle, 'right');
        },
        isApplied: function isApplied() {
          return ImageFormatClass.value(_this.activeEle) === 'right';
        }
      }, {
        icon: "<svg viewbox=\"0 0 18 18\">\n        <path class=\"ql-fill\" d=\"M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z\"/>\n        <path class=\"ql-fill\" d=\"M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z\"/>\n        <rect class=\"ql-fill\" x=\"2\" y=\"6\" width=\"14\" height=\"6\" rx=\"1\" ry=\"1\"/>\n      </svg>",
        apply: function apply() {
          ImageFormatClass.add(_this.activeEle, 'full');
        },
        isApplied: function isApplied() {
          return ImageFormatClass.value(_this.activeEle) === 'full';
        }
      }];
    }
  }, {
    key: "_addToolbarButtons",
    value: function _addToolbarButtons() {
      var _this2 = this;

      var buttons = [];
      this.alignments.forEach(function (alignment, idx) {
        var button = document.createElement('span');
        buttons.push(button);
        button.innerHTML = alignment.icon;
        button.addEventListener('click', function () {
          // deselect all buttons
          buttons.forEach(function (button) {
            return button.style.filter = '';
          });

          if (alignment.isApplied()) {
            // If applied, unapply
            ImageFormatClass.remove(_this2.activeEle);
          } else {
            // otherwise, select button and apply
            _this2._selectButton(button);

            alignment.apply();
          } // image may change position; redraw drag handles


          _this2.requestUpdate();
        });
        Object.assign(button.style, _this2.options.styles.toolbarButton);

        if (idx > 0) {
          button.style.borderLeftWidth = '0';
        }

        Object.assign(button.children[0].style, _this2.options.styles.toolbarButtonSvg);

        if (alignment.isApplied()) {
          // select button if previously applied
          _this2._selectButton(button);
        }

        _this2.toolbar.appendChild(button);
      }); // Edit button

      var button = document.createElement('span');
      button.innerHTML = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M 12.9 2 L 11.3 3.6 L 14.8 7 L 16.3 5.5 L 12.9 2 Z M 9.3 5.5 L 2 12.2 L 2 15.5 L 5.7 15.5 L 13 8.9 L 9.3 5.5 Z"></path></svg>';
      Object.assign(button.style, this.options.styles.toolbarButton);
      button.style.borderLeftWidth = '0';
      button.addEventListener('click', function () {
        _this2.quill.emitter.emit('resize-edit', _this2.activeEle, _this2.blot);
      });
      this.toolbar.appendChild(button);
    }
  }, {
    key: "_selectButton",
    value: function _selectButton(button) {
      button.style.filter = 'invert(20%)';
    }
  }]);

  return Toolbar;
}(BaseModule);

export { Toolbar as default };